import React, { FC, ReactNode } from "react";
import ErrorHeader from "./components/errorHeader";

type ErrorLayoutProps = { pageTitle: string; children?: ReactNode };

/**
 * Layout for Error pages: like NotFound & Error
 */
const ErrorLayout: FC<ErrorLayoutProps> = ({ pageTitle, children }) => {
  return (
    <>
      <div className="ss:h-screen ss:overflow-y-auto ss:flex ss:flex-col ss:py-10 ss:space-y-6">
        <ErrorHeader />
        <div className="ss:container ss:flex-grow ss:flex ss:items-center">
          <div className="ss:grid ss:md:grid-cols-8 ss:lg:grid-cols-12 ss:flex-grow">
            <div className="ss:col-span-full ss:md:col-span-6 ss:md:col-start-2 ss:lg:col-start-4">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorLayout;
